export class PlantDropdownDto {
  public plantId: number;
  public name: string;
  public fullname?: string;
  public vpCompanyId: number | null;
}
